import React from "react";
import './MahutiInputVisitors.css'
function MahutiInputVisitors(props) {
    

    const onCustomerChange = (num) => {
        props.setVisitorsNumber(num);
    }

    return <div className="alef info_block py-lg-4 py-1 border border-end-0 border-start-0 border-top-0">
        <div className="mahutiInputVisitors row align-items-center">
            <div className="col-lg-4 col header-detail text-start">
                {props.visitor}
            </div>
            <div className="col-lg-3 col middle">
                {props.price ? `${props.price}₪` : ''}
            </div>
            <div className="col-lg-5 col-7">
                <div className="bd-highlight ">
                    <div className="btn-group align-items-center justify-content-end d-flex">
                        <button className="sign-btn plus d-flex justify-content-center align-items-center" onClick={() => onCustomerChange(props.visitorsNumber + 1)} disabled={props.disabled}>
                            <span className="plus">
                                +
                            </span>
                        </button>
                        <div className="input-number d-flex" style={{minWidth: '17px'}}>
                            {props.visitorsNumber}
                        </div>
                        <button className="sign-btn minus d-flex justify-content-center align-items-center" onClick={() => onCustomerChange(props.visitorsNumber - 1)} disabled={props.isInternal ? props.visitorsNumber ===0 : props.visitorsNumber === 1}>
                            <span className="minus">
                                -
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
}

export default MahutiInputVisitors;